import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';


// Component for grouping items in a select
export default function RenderMenu({ focusedOption, focusOption, options, selectValue, groupBy, valueKey, labelKey, optionRenderer }) {
  const groupedOptions = groupBy(options);

  return (
    <div>
      {_.map(groupedOptions, (groupOptions, key) =>
        <div key={key}>
          <div className="select-option-group">{key}</div>
          {_.map(groupOptions, (option) =>
            <div
              className={classNames('Select-option', {
                'is-selected': selectValue[valueKey] === option[valueKey],
                'is-focused': focusedOption[valueKey] === option[valueKey]
              })}
              role="option"
              key={option[valueKey]}
              onClick={() => selectValue(option)}
              onMouseEnter={() => focusOption(option)}
            >
              {optionRenderer ? optionRenderer(option) : option[labelKey]}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

RenderMenu.propTypes = {
  focusedOption: PropTypes.object.isRequired,
  focusOption: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectValue: PropTypes.func.isRequired,
  groupBy: PropTypes.func.isRequired,
  valueKey: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
  optionRenderer: PropTypes.func
};
